import { TranslationDictionary } from './types';

export const de: TranslationDictionary = {
  app: {
    modes: {
      isoBlock: 'ISO.BLOCK',
      blockSystem: 'BLOCK.SYSTEM',
      systemTable: 'SYSTEM.TABLE',
    },
    headers: {
      auth: 'Benutzer',
    },
    mobileRestriction: {
      title: 'Bitte Tablet oder Desktop verwenden',
      message: 'Diese Anwendung ist für Tablets und Desktop-PCs optimiert. Bitte nutzen Sie ein größeres Gerät, um Iso.block, Block.system oder System.table zu verwenden.',
      backToLanding: 'Zur Startseite',
    },
  },
  common: {
    save: 'Speichern',
    saveAs: 'Speichern unter...',
    load: 'Laden',
    cancel: 'Abbrechen',
    apply: 'Übernehmen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    ok: 'OK',
    new: 'Neu',
    newPart: 'Neues Bauteil',
    newFile: 'Neue Datei',
    export: 'Exportieren',
    import: 'Importieren',
    importPart: 'Import .isompart',
    exportSvg: 'Export SVG',
    print: 'Drucken',
    back: 'Zurück',
    close: 'Schließen',
    symbolLibrary: 'Symbolbibliothek',
    backgroundSettings: 'Hintergrund-Einstellungen',
    helpAndShortcuts: 'Hilfe & Tastaturkürzel',
    rename: 'Umbenennen',
    duplicate: 'Duplizieren',
    folder: 'Ordner',
    drawing: 'Zeichnung',
    signIn: 'Anmelden',
    signUp: 'Registrieren',
    startNow: 'Jetzt Starten',
    yes: 'Ja',
    no: 'Nein',
    accept: 'Akzeptieren',
    reset: 'Zurücksetzen',
    create: 'Erstellen',
    optional: 'optional',
    toLandingPage: 'Zur Landing Page',
  },
  menu: {
    file: 'Datei',
    edit: 'Bearbeiten',
    view: 'Ansicht',
    settings: 'Einstellungen',
    help: 'Hilfe',
    tools: 'Werkzeuge',
    importExport: 'Import/Export',
  },
  editor: {
    tools: {
      select: 'Auswählen',
      line: 'Linie',
      move: 'Verschieben',
      circle: 'Kreis',
      arc: 'Bogen',
      text: 'Text',
      dimension: 'Bemaßung',
      eraser: 'Radiergummi',
      connection: 'Verbindung',
      pan: 'Hand',
      angle: 'Winkel',
      fillet: 'Abrunden',
      tangentArc: 'Tangentialbogen',
      centeredArc: 'Zentrierter Bogen (Hut)',
      shape: 'Fläche',
      spline: 'Spline',
      grid: 'Raster',
      ruler: 'Lineal',
      cable: 'Leitung',
      magnet: 'Magnet',
      link: 'Link',
      database: 'Datenbank',
      tag: 'Tag',
    },
    properties: {
      title: 'Eigenschaften',
      color: 'Farbe',
      layer: 'Ebene',
      thickness: 'Stärke',
      noSelection: 'Kein Element ausgewählt',
      selectToEdit: 'Wählen Sie Blöcke, Verbindungen oder Labels aus, um deren Eigenschaften zu bearbeiten',
      blockProperties: 'Block-Eigenschaften',
      blocksSelected: '{count} Blöcke ausgewählt',
      connectionProperties: 'Verbindungseigenschaften',
      connectionsSelected: '{count} Verbindungen ausgewählt',
      connectionInfo: 'Informationen',
      connectedComponents: 'Angeschlossene Bauteile',
      multiWay: 'Multi-Way-Verbindung',
      standardConnection: 'Standard-Verbindung zwischen 2 Bauteilen',
      multiWayConnection: '{count}-Wege-Verbindung (T-Stück, Kreuzung, etc.)',
      connectionAttributes: 'Verbindungs-Attribute',
      addAttribute: 'Attribut hinzufügen',
      copyPasteTip: 'Tipp: Strg+C um Attribute zu kopieren, Strg+V zum Einfügen',
      multiSelectionWarning: 'Mehrfachauswahl - Eigenschaften können nicht bearbeitet werden',
      systems: 'Systeme',
      systemAttributes: 'System-Attribute',
      labelProperties: 'Label-Eigenschaften',
      noLabelSelected: 'Kein Label ausgewählt',
      clickLabelToView: 'Klicke auf ein Label, um Details anzuzeigen',
      noSystems: 'Keine Systeme vorhanden',
      connectToCreateSystems: 'Verbinde Bauteile, um Systeme zu erstellen',
      emptyBlockSelection: 'Kein Block ausgewählt',
      emptyConnectionSelection: 'Keine Verbindung ausgewählt',
      clickConnectionToView: 'Klicke auf eine Verbindung, um Attribute anzuzeigen',
    },
    status: {
      saved: 'Gespeichert',
      saving: 'Speichert...',
      error: 'Fehler',
      ready: 'Bereit',
    },
    view: {
      zoomIn: 'Vergrößern',
      zoomOut: 'Verkleinern',
      zoomReset: 'Zoom zurücksetzen',
      toggleGrid: 'Raster umschalten',
      toggleSnap: 'Raster-Fang umschalten',
    },
    actions: {
      undo: 'Rückgängig',
      redo: 'Wiederherstellen',
      openMenu: 'Menü öffnen',
      trim: 'Kürzen',
    },
  },
  browser: {
    drawings: 'Zeichnungen',
    noDrawings: 'Keine Zeichnungen vorhanden',
    confirmDeleteDrawing: 'Zeichnung "{name}" wirklich löschen?',
    confirmDeleteFolder: 'Ordner "{name}" und alle Inhalte wirklich löschen?',
    promptNewDrawingName: 'Name der neuen Zeichnung:',
    promptNewFolderName: 'Name des neuen Ordners:',
    createPlan: 'Plan erstellen',
    deletePlan: 'Plan löschen',
    confirmDeletePlan: 'Plan "{name}" wirklich löschen?',
    validation: {
      nameRequired: 'Name darf nicht leer sein',
    },
  },
  sidebar: {
    tabs: {
      browser: 'Browser',
      parts: 'Bauteile',
      subsystems: 'Subsysteme',
      labels: 'Beschriftungen',
    },
    parts: {
      title: 'Bauteil-Bibliothek',
      search: 'Suchen...',
      importPart: '.isompart importieren',
      libraryImport: 'Lib Import',
      libraryExport: 'Lib Export',
      notFound: 'Keine Bauteile gefunden',
      empty: 'Keine Bauteile in der Bibliothek',
      importHint: 'Importieren Sie .isompart Dateien',
      available: '{count} Bauteile verfügbar',
      delete: 'Bauteil löschen',
      dragToPlace: 'Ziehen zum Platzieren',
      info: {
        elements: '{count} Elemente',
        sockets: '{count} Socket{suffix}',
        attributes: '{count} Attribut{suffix}',
      },
      messages: {
        added: 'Bauteil "{name}" zur Bibliothek hinzugefügt',
        deleted: 'Bauteil "{name}" gelöscht',
        imported: '{count} neue Bauteil(e) importiert',
        alreadyExists: 'Alle Bauteile sind bereits vorhanden',
        emptyLibrary: 'Bibliothek ist leer',
        exportCancelled: 'Export abgebrochen',
        importError: 'Fehler beim Laden',
        exported: 'Bibliothek mit {count} Bauteilen exportiert',
        invalidFormat: 'Ungültiges Bibliotheks-Format',
      },
    },
    labels: {
      title: 'Beschriftungen',
      search: 'Beschriftung suchen...',
      notFound: 'Keine Beschriftungen gefunden',
      empty: 'Keine Beschriftungen vorhanden',
      rows: '{count} Zeile{suffix}',
      columns: '{count} Spalte{suffix}',
      confirmDelete: 'Beschriftung "{name}" wirklich löschen?',
      more: '+{count} weitere',
    },
    pipe: {
      noTypes: 'Keine Leitungstypen definiert',
    },
  },
  landing: {
    title: 'IsoCAD',
    subtitle: 'Professionelle isometrische Zeichnungen im Browser',
    enter: 'App Starten',
    efficiencyBooster: 'Der Effizienz-Booster für Isometrie',
    heroTitle: 'Isometrische Pläne in <span className="text-purple-600">Minuten</span>, nicht Stunden.',
    heroDescription: 'Erstelle komplexe Rohrleitungspläne und Systemdiagramme direkt im Browser. Vom Block zur Stückliste mit einem Klick – ohne teure Installation.',
    features: {
      browserReady: 'Sofort einsatzbereit im Browser',
      autoBom: 'Automatische Stücklisten & Auswertungen',
      parametric: 'Volle parametrische Kontrolle',
      customParts: 'Individuelle Bauteil-Erstellung',
    },
    cta: {
      getStarted: 'Kostenlos loslegen',
      noCreditCard: 'Keine Kreditkarte erforderlich. Sofortiger Zugang.',
      readyForNextStep: 'Bereit für den nächsten Schritt?',
      startFree: 'Starte jetzt kostenlos und erlebe, wie einfach isometrische Planung sein kann.',
      registerFree: 'Kostenlos registrieren',
    },
    feature1: {
      title: 'Einfachheit trifft Präzision',
      description: 'Vergiss überladene Menüs. Isoblock fokussiert sich auf das Wesentliche: Schnelles Zeichnen mit intelligenten Snapping-Funktionen und intuitiven Werkzeugen.',
      list: {
        grid: 'Intelligentes Raster-System für perfekte Isometrie',
        dragDrop: 'Drag & Drop Workflow',
        autoDim: 'Automatische Bemaßung und Beschriftung',
      },
    },
    feature2: {
      title: 'Parametrik & Individualisierung',
      description: 'Jedes Projekt ist anders. Erstelle deine eigenen parametrischen Blöcke und definiere Attribute, die genau zu deinen Anforderungen passen.',
      boxTitle: 'Das Power-Feature: Attribute',
      boxDescription: 'Definiere Metadaten wie Material, Druckstufe oder Hersteller direkt am Bauteil. Diese Daten fließen automatisch in deine Auswertungen ein.',
    },
    feature3: {
      title: 'Automatische Auswertungen',
      description: 'Deine Zeichnung ist mehr als nur ein Bild. Isoblock generiert im Hintergrund automatisch Stücklisten, Schweißnaht-Listen und Massenauszüge.',
      list: {
        sync: 'Live-Synchronisation zwischen Zeichnung und Tabelle',
        grouping: 'Gruppierung und Filterung nach Systemen',
        export: 'Export für Excel und PDF',
      },
    },
    footer: {
      rights: '&copy; {year} Isoblock. Alle Rechte vorbehalten.',
      imprint: 'Impressum',
      privacy: 'Datenschutz',
      terms: 'AGB',
    },
    badges: {
      validationActive: 'Validierung aktiv',
      connectionsChecked: 'Alle Verbindungen geprüft',
    },
  },
  help: {
    title: 'Hilfe & Dokumentation',
    description: 'Eine Übersicht der Werkzeuge, Tastenkürzel und Tipps & Tricks.',
    tabs: {
      tools: 'Werkzeuge',
      shortcuts: 'Tastenkürzel',
      tips: 'Tipps & Tricks',
    },
    toolDescriptions: {
      select: 'Elemente auswählen und bearbeiten. Klicken Sie auf ein Element, um es auszuwählen.',
      line: 'Linien zeichnen zwischen zwei Punkten. Erster Klick = Startpunkt, zweiter Klick = Endpunkt. Die Punkte rasten automatisch am isometrischen Raster ein.',
      shape: 'Polygone zeichnen. Klicken Sie mehrere Punkte, um die Form zu definieren. Klicken Sie auf den ersten Punkt oder drücken Sie die Leertaste, um die Form zu schließen.',
      text: 'Text hinzufügen. Klicken Sie auf die Position und geben Sie den Text ein.',
      pan: 'Canvas verschieben. Klicken und ziehen, um die Ansicht zu bewegen. Alternativ: Mittlere Maustaste oder Shift+Drag in jedem Werkzeug.',
    },
    sections: {
      view: 'Ansicht',
      file: 'Datei',
      edit: 'Bearbeiten',
    },
    tips: {
      grid: {
        title: 'Isometrisches Grid',
        desc: 'Das isometrische Grid verwendet 30°-Winkel für eine pseudo-3D-Darstellung. Alle Punkte rasten automatisch am Grid ein.',
        sub: 'Der rote Punkt markiert den Ursprung (0,0).',
      },
      shapes: {
        title: 'Flächen erstellen',
        desc: 'Um eine Fläche zu schließen, klicken Sie auf den ersten Punkt erneut. Mindestens 3 Punkte sind erforderlich.',
      },
      nav: {
        title: 'Navigation',
        zoom: 'Zoomen: Mausrad oder +/- Tasten',
        pan: 'Schwenken: Mittlere Maustaste, Shift+Drag oder H-Werkzeug',
      },
      props: {
        title: 'Eigenschaften bearbeiten',
        desc: 'Wählen Sie ein Element aus, um dessen Eigenschaften im rechten Panel zu bearbeiten. Sie können Farben, Strichstärken, Füllung und mehr anpassen.',
      },
      save: {
        title: 'Bauteile speichern',
        desc: 'Speichern Sie Bauteile als .isompart-Dateien oder in der integrierten Bibliothek. Die Bibliothek verwendet den LocalStorage des Browsers.',
      },
    },
  },
  attributes: {
    title: 'Attribute',
    add: 'Hinzufügen',
    name: 'Name',
    type: 'Typ',
    value: 'Wert',
    description: 'Beschreibung',
    noAttributes: 'Keine Attribute vorhanden',
    clickToAdd: 'Klicke auf + zum Hinzufügen',
    original: 'Original',
    automatic: 'Automatisch',
    types: {
      string: 'Text',
      number: 'Dezimalzahl',
      integer: 'Ganzzahl',
      boolean: 'Ja/Nein',
      url: 'URL',
      email: 'E-Mail',
      dimension: 'Bemaßung',
      angle: 'Winkel',
      dn: 'DN (Nennweite)',
      dnReduction: 'DN Reduktion',
      insertionDepth: 'Einstecktiefe',
      roughness: 'Rauhigkeit',
      flowRate: 'Volumenstrom',
      pressureLoss: 'Druckverlust',
      velocity: 'Geschwindigkeit',
      uValue: 'U-Wert',
      thermalConductivity: 'Wärmeleitfähigkeit',
      wallThickness: 'Wandstärke',
      insulationThickness: 'Isolierstärke',
      temperature: 'Temperatur',
      pressure: 'Druck',
      power: 'Leistung',
      massFlow: 'Massenstrom',
      density: 'Dichte',
      viscosity: 'Viskosität',
    },
    groups: {
      general: 'Allgemein',
      tgaNominal: 'TGA - Nennweiten',
      tgaGeometry: 'TGA - Geometrie',
      tgaFlow: 'TGA - Strömung',
      tgaThermic: 'TGA - Thermik',
      tgaPhysical: 'TGA - Physikalisch',
    },
  },
  background: {
    title: 'Hintergrund-Einstellungen',
    visible: 'Hintergrund anzeigen',
    mode: 'Hintergrund-Modus',
    color: 'Hintergrundfarbe',
    modes: {
      isometric: 'Isometrisches Gitter',
      cartesian: 'Kartesisches Raster',
      dots: 'Gepunktet',
      none: 'Leer',
      description: 'Kein Hintergrund wird angezeigt. Nur die Hintergrundfarbe ist sichtbar.',
    },
    isometric: {
      angle: 'Winkel (Grad)',
      gridSize: 'Gitterabstand (mm)',
      lineColor: 'Linienfarbe',
      lineWidth: 'Linienstärke',
      pointColor: 'Punktfarbe',
      pointSize: 'Punktgröße',
    },
    cartesian: {
      gridSize: 'Gitterabstand (mm)',
      lineColor: 'Linienfarbe',
      lineWidth: 'Linienstärke',
      showMinor: 'Hilfslinien anzeigen',
      minorDivisions: 'Unterteilungen',
      minorColor: 'Hilfslinien-Farbe',
    },
    dots: {
      gridSize: 'Punktabstand (mm)',
      color: 'Punktfarbe',
      size: 'Punktgröße',
    },
  },
  dialogs: {
    connection: {
      title: 'Verbindungspunkt erstellen',
      label: 'Bezeichnung',
      placeholder: 'z.B. Eingang, Ausgang, Anschluss',
    },
    blockDisplay: {
      title: 'Anzeigeeinstellungen',
      useOverrides: 'Block-spezifische Einstellungen verwenden',
      overridesDesc: 'Überschreibe die globalen Anzeigeeinstellungen nur für diesen Block.',
      lineWidth: 'Linienstärke-Multiplikator',
      connectionSize: 'Socket-Größen-Multiplikator',
      fontSize: 'Schriftgröße-Multiplikator',
      global: 'Global',
      colorOverride: 'Farbüberladung',
      noOverrides: 'Dieser Block verwendet die globalen Anzeigeeinstellungen.',
    },
    dimensionEdit: {
      title: 'Bemaßung bearbeiten',
      description: 'Wahre Länge für Bauteillisten eingeben. Die berechnete Länge wird überschrieben.',
      calculatedLength: 'Berechnete Länge',
      calculatedDesc: 'Automatisch berechnet basierend auf Geometrie',
      actualLength: 'Wahre Länge',
      actualDesc: 'Dieser Wert wird für Bauteillisten verwendet',
      overridden: 'Wert wurde überschrieben',
      displayed: 'Angezeigt',
    },
    addAttribute: {
      titleNew: 'Neues Attribut erstellen',
      titleEdit: 'Attribut bearbeiten',
      nameLabel: 'Attribut-Name *',
      namePlaceholder: 'z.B. Material, DN, Temperatur',
      typeLabel: 'Datentyp',
      targetLabel: 'Zu welchen Objekten hinzufügen? *',
      targetBlocks: 'Bauteile (Blöcke)',
      targetAllBlocks: 'Alle Bauteile ({count} Instanzen)',
      targetSpecificBlock: 'Spezifisches Bauteil',
      targetConnections: 'Alle Verbindungen ({count} Instanzen)',
      fillModeLabel: 'Wie sollen die Werte ausgefüllt werden?',
      fillEmpty: 'Leer lassen',
      fillEmptyDesc: 'Alle Werte bleiben leer',
      fillSame: 'Gleicher Wert für alle',
      fillSameDesc: 'Alle Objekte erhalten denselben Wert',
      fillNumbering: 'Fortlaufende Nummerierung',
      fillNumberingDesc: 'Objekte werden durchnummeriert (z.B. 1, 2, 3, ...)',
      fillCustom: 'Benutzerdefiniert',
      fillCustomDesc: 'Werte manuell nach Erstellung eingeben',
      startValue: 'Startwert',
      prefix: 'Präfix (optional)',
      suffix: 'Suffix (optional)',
      preview: 'Vorschau:',
      createBtn: 'Attribut erstellen',
      saveBtn: 'Speichern',
      validationName: 'Bitte geben Sie einen Attributnamen ein.',
      validationTarget: 'Bitte wählen Sie mindestens einen Objekttyp aus.',
    },
    borderAreas: {
      title: 'Bereiche automatisch formatieren',
      hint: 'Hinweis: Diese Einstellungen formatieren die Rahmenlinien der Tabellen-Bereiche (Header und Daten) automatisch für optimale visuelle Hierarchie.',
      headerBorder: 'Header-Bereich (dick umranden)',
      dataBorder: 'Daten-Bereich (dick umranden)',
      innerGrid: 'Innengitter (dünne Linien)',
      zebraStripes: 'Zebra-Streifen (alternierende Hintergrundfarben)',
      zebraStripesDesc: 'Jede zweite Zeile erhält einen leicht dunkleren Hintergrund für bessere Lesbarkeit.',
      color: 'Farbe:',
      width: 'Dicke:',
      thin: '1px (dünn)',
      standard: '2px (standard)',
      medium: '3px (mittel)',
      thick: '4px (dick)',
      apply: 'Anwenden',
    },
    mergeColumns: {
      title: 'Spalten zusammenführen',
      intro: 'Folgende Spalten werden zusammengeführt:',
      labelName: 'Anzeigename für die zusammengeführte Spalte:',
      placeholder: 'z.B. Länge',
      mergeBtn: 'Zusammenführen',
    },
    mergedColumn: {
      title: 'Zusammengeführte Spalte',
      columnName: 'Spaltenname:',
      attributes: 'Zusammengeführte Attribute ({count}):',
      info: 'ℹ️ Diese Spalte zeigt Werte aus mehreren Attributen. Objekte mit mehreren Werten wurden in separate Zeilen aufgeteilt.',
      unmergeBtn: 'Zusammenführung auflösen',
    },
    renameColumn: {
      title: 'Anzeigenamen ändern',
      label: 'Neuer Anzeigename:',
      placeholder: 'z.B. Durchmesser&#10;außen',
      hint: 'Der Anzeigename überschreibt nur die Darstellung in der Tabelle. Das Original-Attribut bleibt unverändert.',
      tip: 'Tipp: Drücke Enter für Zeilenumbrüche.',
      changeBtn: 'Ändern',
    },
  },
  sentry: {
    status: {
      banner: {
        title: 'Entwicklermodus: Sentry deaktiviert',
        desc: 'Fehler werden nur in der Konsole protokolliert',
      },
    },
    test: {
      title: 'Fehler-Tracking Test',
      desc: 'Sentry Error-Tracking ist aktiv. Mit diesem Button können Sie einen Test-Error senden, um zu überprüfen, ob die Fehlererfassung korrekt funktioniert.',
      button: 'Test-Error an Sentry senden',
      note: 'Der Test-Error wird mit dem Tag "type: test" markiert und erscheint in Ihrem Sentry-Dashboard.',
    },
  },
  feedback: {
    title: 'Feedback senden',
    context: {
      title: 'Auto-erkannter Kontext',
      blocks: 'Blöcke',
      connections: 'Verbindungen',
      tool: 'Tool',
    },
    emailDisabled: {
      title: 'E-Mail-Versand deaktiviert',
      desc: 'EmailJS ist nicht konfiguriert. Feedback wird nur in der Console geloggt.',
      showConfig: 'Fehlende Konfiguration anzeigen',
      setupGuide: 'Siehe EMAILJS_SETUP.md für Setup-Anleitung',
    },
    category: {
      label: 'Was möchtest du melden?',
      bug: 'Bug',
      feature: 'Feature',
      improvement: 'Verbesserung',
    },
    description: {
      label: 'Beschreibung',
      placeholders: {
        bug: 'Was ist passiert?\n- [Beschreibe das Problem hier]\n\nErwartetes Verhalten?\n- [Was sollte stattdessen passieren?]\n\nSchritte zur Reproduktion?\n1. [Erster Schritt]\n2. [Zweiter Schritt]\n3. [Dritter Schritt]',
        feature: 'Welche Funktion wünschst du dir?\n- [Beschreibe die gewünschte Funktion]\n\nWarum brauchst du diese Funktion?\n- [Erkläre den Anwendungsfall]\n\nWie sollte es funktionieren?\n- [Beschreibe das gewünschte Verhalten]',
        improvement: 'Was könnte besser sein?\n- [Beschreibe was verbessert werden sollte]\n\nDein Vorschlag?\n- [Wie sollte es stattdessen sein?]',
      },
    },
    options: {
      title: 'Zusätzliche Infos',
      screenshot: 'Canvas-Screenshot anhängen (hilft bei Bug-Fixes!)',
      devDetails: 'Entwickler-Details anhängen',
    },
    submit: {
      button: 'Absenden',
      sending: 'Wird gesendet...',
      success: 'Feedback gesendet! Vielen Dank! 🎉',
      error: 'Fehler beim Senden',
      screenshotSuccess: 'Screenshot aufgenommen!',
      screenshotError: 'Screenshot konnte nicht erstellt werden',
      noCanvas: 'Kein Canvas-Element gefunden',
      validation: 'Bitte gib eine Beschreibung ein',
      limitReached: 'Noch {count} Feedback{suffix} in dieser Stunde möglich',
    },
    footer: 'Dein Feedback hilft uns besser zu werden! Danke! 💙',
  },
  print: {
    settings: 'Einstellungen',
    planName: 'Planname',
    format: 'Format',
    orientation: 'Ausrichtung',
    scale: 'Maßstab (Viewport)',
    titleBlock: 'Schriftkopf Daten',
    project: 'Bauvorhaben / Projekt',
    client: 'Bauherr',
    projectNumber: 'Projekt-Nr.',
    planNumber: 'Plan-Nr.',
    date: 'Datum',
    drawnBy: 'Bearbeiter',
    view: 'Ansicht',
    showCropMarks: 'Druckmarken anzeigen',
    showIsoGrid: 'Iso-Raster anzeigen',
    print: 'Drucken',
    dxf: 'DXF',
    landscape: 'Quer',
    portrait: 'Hoch',
    custom: 'Benutzerdef.',
    placeholders: {
      project: 'Projektname...',
      client: 'Bauherr...',
    },
    messages: {
      viewportUnlocked: 'Viewport entsperrt: Inhalt verschieben/zoomen',
      viewportLocked: 'Viewport fixiert',
      centerView: 'Inhalt zentrieren',
      centerContent: 'Ansicht zentriert',
      exportStarted: 'DXF Export gestartet',
      exportFailed: 'DXF Export fehlgeschlagen',
      noBlocks: 'Keine Blöcke zum Zentrieren',
      invalidCoords: 'Ungültige Koordinaten',
      viewCentered: 'Ansicht zentriert',
      titleBlockActive: 'Plankopf-Editor aktiv',
      load: 'Laden',
      save: 'Speichern',
      done: 'Fertig',
      saveTemplateTitle: 'Plankopf speichern',
      saveTemplateDesc: 'Speichern Sie das aktuelle Layout als Vorlage für zukünftige Pläne.',
      loadTemplateTitle: 'Plankopf laden',
      loadTemplateDesc: 'Wählen Sie eine gespeicherte Vorlage aus, um das aktuelle Layout zu ersetzen.',
      noTemplates: 'Keine Vorlagen gespeichert',
      shortcuts: 'Entf: Inhalt leeren | Shift+Entf: Zeile löschen | Alt+Entf: Spalte löschen',
    },
  },
  table: {
    headers: {
      added: 'Header-Zeile hinzugefügt',
      inserted: 'Header-Zeile eingefügt',
      deleted: 'Header-Zeile gelöscht',
      reset: 'Alle Header-Zeilen zurückgesetzt',
      updated: 'Überschrift aktualisiert',
    },
    columns: {
      renamed: 'Spaltenname aktualisiert',
      merged: '{count} Spalten horizontal verschmolzen',
      unmerged: 'Verschmelzung aufgehoben',
    },
    cells: {
      noSelection: 'Keine Zellen ausgewählt',
      minTwo: 'Mindestens 2 Zellen auswählen',
      singleMerged: 'Genau 1 verbundene Zelle auswählen',
      notMerged: 'Zelle ist nicht verbunden',
      notAdjacent: 'Zellen müssen nebeneinander liegen',
      notAdjacentVertical: 'Zellen müssen vertikal nebeneinander liegen',
      verticalSameColumn: 'Nur Zellen aus der gleichen Spalte können vertikal verbunden werden',
      invalidSelection: 'Ungültige Zellauswahl',
      horizontalMainError: 'Horizontales Verbinden der Hauptzeile wird nicht unterstützt',
      mainMergeError: 'Hauptzeile kann nur mit der untersten Header-Zeile verbunden werden',
      mainMixError: 'Kann nicht Main-Spalten mit Header-Zeilen mischen',
      mainVerticalError: 'Main-Spalten können nur horizontal verschmolzen werden',
      rectangleError: 'Zellen müssen ein Rechteck bilden',
      mergedHorizontal: 'Zellen horizontal verbunden',
      mergedVertical: 'Zellen vertikal verbunden',
      mergedMain: 'Zellen mit Hauptzeile verbunden',
      merged2D: 'Zellen verschmolzen ({width}x{height})',
      splitHorizontal: 'Zelle horizontal getrennt',
      splitVertical: 'Zelle vertikal getrennt',
      split2DError: '2D-verbundene Zellen können noch nicht getrennt werden',
      cellNotFound: 'Zelle nicht gefunden',
    },
    borders: {
      presetApplied: 'Rahmen-Vorlage "{preset}" angewendet',
      widthApplied: 'Linienstärke {width}px angewendet',
      formatted: 'Bereiche formatiert',
      reset: 'Header-Zeilen und Rahmenlinien zurückgesetzt',
    },
    status: {
      rebuilt: 'Tabelle neu aufgebaut: {count} Zeilen',
      projectLoaded: 'Projekt geladen{details}',
      loadError: 'Fehler beim Laden des Projekts',
      saveError: 'Fehler beim Speichern',
    },
    grouping: {
      activated: 'Gruppierung aktiviert',
      deactivated: 'Gruppierung deaktiviert',
    },
    groupByPanel: {
      title: 'Gruppierung',
      groupBy: 'Gruppieren nach',
      dragInstruction: 'Spalte hierher ziehen oder unten auswählen',
      aggregations: 'Aggregationen',
      subtotals: 'Zwischensummen anzeigen',
      grandTotal: 'Gesamtsumme anzeigen',
      reset: 'Zurücksetzen',
      level: 'Ebene',
      addColumn: 'Spalte hinzufügen...',
      none: 'Keine',
      count: 'Anzahl',
      sum: 'Summe',
      avg: 'Durchschnitt',
      min: 'Minimum',
      max: 'Maximum',
      first: 'Erster',
      last: 'Letzter',
      unique_count: 'Eindeutige',
    },
    totals: {
      activated: 'Summenzeile aktiviert',
      deactivated: 'Summenzeile deaktiviert',
    },
    printDialog: {
      title: 'Drucken / Exportieren',
      tabs: {
        area: 'Bereich',
        format: 'Format',
        metadata: 'Metadaten',
        preview: 'Vorschau',
      },
      presets: {
        title: 'Vorlagen',
        desc: 'Schnellkonfigurationen für häufige Export-Szenarien',
        saveCurrent: 'Aktuelle Config speichern',
        reset: 'Auf Standard zurücksetzen',
        standardPresets: 'Standard-Vorlagen',
        userPresets: 'Eigene Vorlagen',
        deleteConfirmTitle: 'Vorlage löschen',
        deleteConfirmDesc: 'Möchten Sie die Vorlage "{name}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        placeholderName: 'z.B. Mein Export',
        placeholderDesc: 'Optional',
        saveTitle: 'Vorlage speichern',
        saveDesc: 'Aktuelle Konfiguration als wiederverwendbare Vorlage speichern',
        nameLabel: 'Vorlagen-Name *',
        descLabel: 'Beschreibung',
        saveBtn: 'Vorlage speichern',
        deleteBtn: 'Löschen',
        items: {
          'preset-full-table-pdf-a4': { name: 'Gesamte Tabelle - PDF (A4)', desc: 'Gesamte Tabelle als PDF im A4-Format exportieren' },
          'preset-full-table-pdf-a3': { name: 'Gesamte Tabelle - PDF (A3)', desc: 'Gesamte Tabelle als PDF im A3-Format exportieren (groß)' },
          'preset-full-table-pdf-letter': { name: 'Gesamte Tabelle - PDF (Letter)', desc: 'Gesamte Tabelle als PDF im US Letter-Format exportieren' },
          'preset-full-table-excel': { name: 'Gesamte Tabelle - Excel (CSV)', desc: 'Gesamte Tabelle als CSV-Datei exportieren' },
          'preset-selection-only-pdf': { name: 'Ausgewählter Bereich - PDF', desc: 'Nur ausgewählte Zellen als PDF exportieren' },
          'preset-compact-pdf': { name: 'Kompaktes PDF', desc: 'Minimale Ränder, keine Metadaten, kleine Schrift' },
          'preset-portrait-a5': { name: 'Kompakt - PDF (A5 Hochformat)', desc: 'Kleinformatiger Export für kompakte Ausdrucke' },
        },
      },
      area: {
        title: 'Druckbereich auswählen',
        subtitle: 'Wählen Sie aus, welcher Teil Ihrer Tabelle exportiert werden soll',
        options: {
          entireTable: { title: 'Gesamte Tabelle', desc: 'Alle sichtbaren Zeilen und Spalten exportieren' },
          selectedRange: { title: 'Ausgewählter Bereich', desc: 'Einen spezifischen Zellbereich exportieren' },
          selectedColumns: { title: 'Ausgewählte Spalten', desc: 'Spezifische Spalten exportieren (alle Zeilen)' },
          selectedRows: { title: 'Ausgewählte Zeilen', desc: 'Spezifische Zeilen exportieren (alle Spalten)' },
          custom: { title: 'Benutzerdefinierte Auswahl', desc: 'Benutzerdefinierten Exportbereich festlegen' },
        },
        range: {
          title: 'Bereich festlegen',
          desc: 'Geben Sie die Start- und End-Indizes für Zeilen/Spalten an',
          startRow: 'Startzeile',
          endRow: 'Endzeile',
          startCol: 'Startspalte',
          endCol: 'Endspalte',
        },
        columns: {
          title: 'Spalten auswählen',
          desc: 'Wählen Sie aus, welche Spalten exportiert werden sollen (alle Zeilen werden eingeschlossen)',
        },
        rows: {
          title: 'Zeilen auswählen',
          desc: 'Wählen Sie aus, welche Zeilen exportiert werden sollen (alle Spalten werden eingeschlossen)',
          rowLabel: 'Zeile {index}',
        },
        headers: {
          title: 'Kopfzeilen-Optionen',
          desc: 'Konfigurieren Sie, welche Kopfzeilen im Export enthalten sein sollen',
          includeColumns: 'Spaltenkopfzeilen einschließen',
          includeRows: 'Mehrstufige Kopfzeilen einschließen',
          noHeaders: '(Keine Kopfzeilen definiert)',
        },
      },
      format: {
        title: 'Ausgabeformat',
        subtitle: 'Wählen Sie das Exportformat und konfigurieren Sie die Optionen',
        exportFormat: {
          title: 'Exportformat',
          desc: 'PDF oder Excel/CSV-Ausgabe wählen',
          pdf: { title: 'PDF-Dokument', desc: 'Professionelles PDF mit Formatierung, Seitenzahlen und Metadaten' },
          excel: { title: 'Excel / CSV', desc: 'Tabellenformat kompatibel mit Excel, Google Sheets usw.' },
        },
        pageSetup: {
          title: 'Seiteneinrichtung',
          desc: 'Seitengröße und Ausrichtung konfigurieren',
          size: 'Seitengröße',
          orientation: 'Ausrichtung',
          portrait: 'Hochformat',
          landscape: 'Querformat',
        },
        margins: {
          title: 'Ränder',
          desc: 'Seitenränder in Millimetern festlegen',
          top: 'Oben (mm)',
          bottom: 'Unten (mm)',
          left: 'Links (mm)',
          right: 'Rechts (mm)',
        },
        typography: {
          title: 'Typografie',
          desc: 'Schriftarten für das PDF',
          size: 'Schriftgröße',
          font: 'Schriftart',
          range: '{min}–{max} pt',
        },
        display: {
          title: 'Anzeigeoptionen',
          desc: 'Zusätzliche PDF-Funktionen',
          gridLines: 'Gitterlinien anzeigen',
          metadataHeader: 'Metadatenüberschrift einbeziehen',
          pageNumbers: 'Seitenzahlen einbeziehen',
          pagePos: 'Position der Seitenzahl',
          posLeft: 'Unten links',
          posCenter: 'Unten zentriert',
          posRight: 'Unten rechts',
          customFields: 'Benutzerdefinierte Felder anzeigen',
          cfNone: 'Nicht anzeigen (nur in PDF-Eigenschaften)',
          cfAbove: 'Über der Tabelle',
          cfBelow: 'Unter der Tabelle',
          cfNote: 'Benutzerdefinierte Felder werden immer in den PDF-Dateieigenschaften gespeichert. Diese Option steuert nur die visuelle Anzeige im Dokument.',
        },
        csv: {
          title: 'CSV-Optionen',
          desc: 'CSV-Exporteinstellungen konfigurieren',
          separator: 'Spaltentrennzeichen',
          comma: 'Komma (,)',
          semicolon: 'Semikolon (;)',
          tab: 'Tab (\\t)',
          formulas: 'Formeln einbeziehen',
          styles: 'Zellstil einbeziehen',
          notSupported: '(nicht in CSV unterstützt)',
          projectMetadata: 'Projektdaten exportieren',
          metadataNote: 'Wenn aktiviert, werden alle Metadaten (Projektname, Autor, benutzerdefinierte Felder, etc.) als Kopfzeilen am Anfang der CSV-Datei eingefügt.',
        },
      },
      metadata: {
        title: 'Dokument-Metadaten',
        subtitle: 'Informationen hinzufügen, die im exportierten Dokument enthalten sein sollen',
        project: {
          title: 'Projektinformationen',
          desc: 'Grundlegende Projektdetails',
          name: 'Projektname *',
          namePlaceholder: 'Projektnamen eingeben',
          description: 'Projektbeschreibung',
          descPlaceholder: 'Optionale Projektbeschreibung oder Notizen',
          version: 'Version',
        },
        author: {
          title: 'Autor & Organisation',
          desc: 'Wer hat dieses Dokument erstellt',
          name: 'Autorenname',
          namePlaceholder: 'Ihr Name',
          company: 'Firma / Organisation',
          companyPlaceholder: 'Firmenname',
        },
        dates: {
          title: 'Datumsangaben',
          desc: 'Informationen zur Projekt-Zeitleiste',
          created: 'Erstellt',
          modified: 'Geändert',
          printed: 'Druckdatum (Nur-Lesen)',
          autoUpdate: 'Wird beim Export automatisch aktualisiert',
        },
        custom: {
          title: 'Benutzerdefinierte Felder',
          desc: 'Eigene Metadaten-Felder hinzufügen (z.B. Abteilung, Standort, Projektnummer)',
          fieldName: 'Feldname',
          value: 'Wert',
          addBtn: 'Neues Feld hinzufügen',
          empty: 'Keine benutzerdefinierten Felder vorhanden. Fügen Sie Felder hinzu, um zusätzliche Informationen zu erfassen.',
        },
      },
      preview: {
        title: 'Druckvorschau',
        subtitle: 'Vorschau Ihres Exports vor dem Download',
        rows: 'Zeilen gesamt',
        cols: 'Spalten',
        headers: 'Kopfzeilen',
        format: 'Format',
        notes: {
          title: 'Export-Hinweise:',
          pdfSize: '• PDF wird mit {size} Seitengröße im {orientation} erstellt',
          pdfFont: '• Schriftart: {font}, Größe: {size}pt',
          pdfGrid: '• Gitterlinien werden eingeschlossen',
          csvSep: '• CSV-Datei verwendet {sep} als Trennzeichen',
          csvCompat: '• Datei ist kompatibel mit Excel, Google Sheets und anderen Tabellenkalkulationsprogrammen',
        },
      },
      actions: {
        back: 'Zurück',
        next: 'Weiter',
        cancel: 'Abbrechen',
        export: 'Jetzt exportieren',
        exporting: 'Exportiere...',
        exportPreview: 'Exportieren',
      },
    },
    toolbar: {
      cells: 'Zellen',
      merge: 'Verbinden',
      split: 'Trennen',
      borders: 'Rahmen',
      borderPresets: 'Rahmen-Vorlagen',
      lineWidth: 'Linienstärke',
      thickness: 'Dicke',
      areas: 'Bereiche',
      table: 'Tabelle',
      column: 'Spalte',
      row: 'Zeile',
      data: 'Daten',
      group: 'Gruppieren',
      totalsRow: 'Summenzeile',
      clearSelection: 'Auswahl aufheben',
      dataRows: 'Datenzeilen',
      reloadValues: 'Werte aus Blöcken neu laden (behält Struktur)',
      resetHeaders: 'Alle Überschriften zurücksetzen',
      resetHeadersConfirm: 'Alle Überschriften und vertikalen Verbindungen zurücksetzen?',
      editBorders: 'Rahmen bearbeiten',
      toggleGrid: 'Gitternetzlinien',
      print: 'Drucken',
      loadTemplate: 'Template laden',
      selection: 'Auswahl: {rows} × {cols}',
      borderPresetsNames: {
        outerThick: 'Außenrahmen dick',
        allBorders: 'Alle Rahmen',
        noBorders: 'Keine Rahmen',
        horizontalOnly: 'Nur horizontal',
        verticalOnly: 'Nur vertikal',
        innerGrid: 'Innengitter',
      },
      columns: 'Spalten',
      rows: 'Zeilen',
      headerRows: 'Header-Zeilen',
    },
    sidebar: {
      attributes: 'Attribute',
      createAttribute: 'Neues Attribut erstellen',
      noAttributes: 'Keine Attribute vorhanden',
      clickToAdd: 'Klicke auf + zum Hinzufügen',
      used: 'verwendet',
      editAttribute: 'Attribut bearbeiten',
      deleteAttribute: 'Attribut löschen',
      confirmDelete: 'Attribut "{name}" wirklich löschen?',
      total: 'gesamt',
      dragHint: 'Ziehe Attribute in die Tabelle',
      types: {
        both: 'Blöcke & Verbindungen',
        block: 'Blöcke',
        connection: 'Verbindungen',
      },
    },
    grid: {
      dragHere: 'Ziehe Attribute hierher',
      dropHere: 'Attribut hier ablegen',
      dragInstruction: 'Wähle Attribute aus dem linken Panel und ziehe sie in die Tabelle',
      addHeaderRow: 'Header-Zeile hinzufügen',
    },
  },
  tutorial: {
    welcome: {
      title: 'Willkommen bei ISOCAD! 👋',
      subtitle: 'Interaktives Tutorial - Lernen Sie ISOCAD in 3 einfachen Schritten',
      workflowTitle: 'Der ISOCAD Workflow:',
      step1Title: 'ISO.BLOCK',
      step1Desc: 'Bauteile konstruieren',
      step2Title: 'BLOCK.SYSTEM',
      step2Desc: 'Systeme bauen & drucken',
      step3Title: 'SYSTEM.TABLE',
      step3Desc: 'Stücklisten erstellen',
      modulesTitle: 'Wählen Sie ein Tutorial-Modul:',
      neverShowAgain: 'Tutorial nicht mehr anzeigen',
      loading: 'Tutorial wird geladen...',
      loadingDesc: 'Bitte warten Sie einen Moment.',
    },
    progress: {
      step: 'Schritt',
      of: 'von',
      completed: 'Abgeschlossen',
      inProgress: 'In Bearbeitung',
    },
    actions: {
      start: 'Tutorial starten',
      next: 'Weiter',
      previous: 'Zurück',
      skip: 'Überspringen',
      close: 'Schließen',
      restart: 'Neu starten',
      complete: 'Abschließen',
      minimize: 'Minimieren',
      maximize: 'Maximieren',
      undo: 'Rückgängig',
      toggleSound: 'Sound an/aus',
    },
    status: {
      completed: '✅ Abgeschlossen',
      notStarted: 'Noch nicht gestartet',
      estimatedTime: 'Geschätzte Dauer',
    },
    messages: {
      conditionNotMet: 'Führen Sie die angegebene Aktion aus, um fortzufahren',
      waitingForAction: 'Warten auf Ihre Aktion...',
      stepComplete: 'Schritt abgeschlossen! 🎉',
      moduleComplete: 'Modul abgeschlossen! 🎉',
      allModulesComplete: 'Alle Module abgeschlossen! Sie sind jetzt ISOCAD-Experte! 🚀',
    },
    keyboard: {
      title: 'Tastaturkürzel',
      hint: 'Oder drücken Sie',
      shortcuts: 'Tastenkürzel anzeigen',
    },
  },
};

export const en: TranslationDictionary = {
  app: {
    modes: {
      isoBlock: 'ISO.BLOCK',
      blockSystem: 'BLOCK.SYSTEM',
      systemTable: 'SYSTEM.TABLE',
    },
    headers: {
      auth: 'User',
    },
    mobileRestriction: {
      title: 'Please use Tablet or Desktop',
      message: 'This application is optimized for tablets and desktop PCs. Please use a larger device to use Iso.block, Block.system or System.table.',
      backToLanding: 'Back to Home',
    },
  },
  common: {
    save: 'Save',
    saveAs: 'Save As...',
    load: 'Load',
    cancel: 'Cancel',
    apply: 'Apply',
    delete: 'Delete',
    edit: 'Edit',
    ok: 'OK',
    new: 'New',
    newPart: 'New Part',
    newFile: 'New File',
    export: 'Export',
    import: 'Import',
    importPart: 'Import .isompart',
    exportSvg: 'Export SVG',
    print: 'Print',
    back: 'Back',
    close: 'Close',
    symbolLibrary: 'Symbol Library',
    backgroundSettings: 'Background Settings',
    helpAndShortcuts: 'Help & Shortcuts',
    rename: 'Rename',
    duplicate: 'Duplicate',
    folder: 'Folder',
    drawing: 'Drawing',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    startNow: 'Start Now',
    yes: 'Yes',
    no: 'No',
    accept: 'Accept',
    reset: 'Reset',
    create: 'Create',
    optional: 'optional',
    toLandingPage: 'To Landing Page',
  },
  menu: {
    file: 'File',
    edit: 'Edit',
    view: 'View',
    settings: 'Settings',
    help: 'Help',
    tools: 'Tools',
    importExport: 'Import/Export',
  },
  editor: {
    tools: {
      select: 'Select',
      line: 'Line',
      move: 'Move',
      circle: 'Circle',
      arc: 'Arc',
      text: 'Text',
      dimension: 'Dimension',
      eraser: 'Eraser',
      connection: 'Connection',
      pan: 'Pan',
      angle: 'Angle',
      fillet: 'Fillet',
      tangentArc: 'Tangent Arc',
      centeredArc: 'Centered Arc',
      shape: 'Shape',
      spline: 'Spline',
      grid: 'Grid',
      ruler: 'Ruler',
      cable: 'Cable',
      magnet: 'Magnet',
      link: 'Link',
      database: 'Database',
      tag: 'Tag',
    },
    properties: {
      title: 'Properties',
      color: 'Color',
      layer: 'Layer',
      thickness: 'Thickness',
      noSelection: 'No element selected',
      selectToEdit: 'Select blocks, connections or labels to edit their properties',
      blockProperties: 'Block Properties',
      blocksSelected: '{count} blocks selected',
      connectionProperties: 'Connection Properties',
      connectionsSelected: '{count} connections selected',
      connectionInfo: 'Information',
      connectedComponents: 'Connected Components',
      multiWay: 'Multi-Way Connection',
      standardConnection: 'Standard connection between 2 components',
      multiWayConnection: '{count}-way connection (T-piece, cross, etc.)',
      connectionAttributes: 'Connection Attributes',
      addAttribute: 'Add Attribute',
      copyPasteTip: 'Tip: Ctrl+C to copy attributes, Ctrl+V to paste',
      multiSelectionWarning: 'Multi-selection - Properties cannot be edited',
      systems: 'Systems',
      systemAttributes: 'System Attributes',
      labelProperties: 'Label Properties',
      noLabelSelected: 'No label selected',
      clickLabelToView: 'Click on a label to view details',
      noSystems: 'No systems available',
      connectToCreateSystems: 'Connect components to create systems',
      emptyBlockSelection: 'No block selected',
      emptyConnectionSelection: 'No connection selected',
      clickConnectionToView: 'Click on a connection to view attributes',
    },
    status: {
      saved: 'Saved',
      saving: 'Saving...',
      error: 'Error',
      ready: 'Ready',
    },
    view: {
      zoomIn: 'Zoom In',
      zoomOut: 'Zoom Out',
      zoomReset: 'Reset Zoom',
      toggleGrid: 'Toggle Grid',
      toggleSnap: 'Toggle Snap',
    },
    actions: {
      undo: 'Undo',
      redo: 'Redo',
      openMenu: 'Open Menu',
      trim: 'Trim',
    },
  },
  browser: {
    drawings: 'Drawings',
    noDrawings: 'No drawings available',
    confirmDeleteDrawing: 'Really delete drawing "{name}"?',
    confirmDeleteFolder: 'Really delete folder "{name}" and all contents?',
    promptNewDrawingName: 'Name of the new drawing:',
    promptNewFolderName: 'Name of the new folder:',
    createPlan: 'Create Plan',
    deletePlan: 'Delete Plan',
    confirmDeletePlan: 'Really delete plan "{name}"?',
    validation: {
      nameRequired: 'Name cannot be empty',
    },
  },
  sidebar: {
    tabs: {
      browser: 'Browser',
      parts: 'Parts',
      subsystems: 'Subsystems',
      labels: 'Labels',
    },
    parts: {
      title: 'Component Library',
      search: 'Search...',
      importPart: 'Import .isompart',
      libraryImport: 'Lib Import',
      libraryExport: 'Lib Export',
      notFound: 'No components found',
      empty: 'No components in library',
      importHint: 'Import .isompart files',
      available: '{count} components available',
      delete: 'Delete component',
      dragToPlace: 'Drag to place',
      info: {
        elements: '{count} elements',
        sockets: '{count} socket{suffix}',
        attributes: '{count} attribute{suffix}',
      },
      messages: {
        added: 'Component "{name}" added to library',
        deleted: 'Component "{name}" deleted',
        imported: '{count} new component(s) imported',
        alreadyExists: 'All components already exist',
        emptyLibrary: 'Library is empty',
        exportCancelled: 'Export cancelled',
        importError: 'Error loading',
        exported: 'Library with {count} parts exported',
        invalidFormat: 'Invalid library format',
      },
    },
    labels: {
      title: 'Labels',
      search: 'Search labels...',
      notFound: 'No labels found',
      empty: 'No labels available',
      rows: '{count} row{suffix}',
      columns: '{count} column{suffix}',
      confirmDelete: 'Really delete label "{name}"?',
      more: '+{count} more',
    },
    pipe: {
      noTypes: 'No pipe types defined',
    },
  },
  landing: {
    title: 'IsoCAD',
    subtitle: 'Professional isometric drawings in the browser',
    enter: 'Start App',
    efficiencyBooster: 'The Efficiency Booster for Isometrics',
    heroTitle: 'Isometric plans in <span className="text-purple-600">Minutes</span>, not hours.',
    heroDescription: 'Create complex piping plans and system diagrams directly in the browser. From block to bill of materials with one click - without expensive installation.',
    features: {
      browserReady: 'Ready to use in the browser',
      autoBom: 'Automatic Bills of Materials & Reports',
      parametric: 'Full Parametric Control',
      customParts: 'Custom Part Creation',
    },
    cta: {
      getStarted: 'Get Started for Free',
      noCreditCard: 'No credit card required. Instant access.',
      readyForNextStep: 'Ready for the next step?',
      startFree: 'Start now for free and experience how easy isometric planning can be.',
      registerFree: 'Register for Free',
    },
    feature1: {
      title: 'Simplicity meets Precision',
      description: 'Forget cluttered menus. Isoblock focuses on the essentials: Fast drawing with intelligent snapping functions and intuitive tools.',
      list: {
        grid: 'Intelligent Grid System for perfect isometrics',
        dragDrop: 'Drag & Drop Workflow',
        autoDim: 'Automatic Dimensioning and Labeling',
      },
    },
    feature2: {
      title: 'Parametrics & Customization',
      description: 'Every project is different. Create your own parametric blocks and define attributes that fit your requirements exactly.',
      boxTitle: 'The Power Feature: Attributes',
      boxDescription: 'Define metadata such as material, pressure rating, or manufacturer directly on the component. This data flows automatically into your reports.',
    },
    feature3: {
      title: 'Automatic Reports',
      description: 'Your drawing is more than just a picture. Isoblock generates bills of materials, weld lists, and quantity takeoffs automatically in the background.',
      list: {
        sync: 'Live synchronization between drawing and table',
        grouping: 'Grouping and filtering by systems',
        export: 'Export for Excel and PDF',
      },
    },
    footer: {
      rights: '&copy; {year} Isoblock. All rights reserved.',
      imprint: 'Imprint',
      privacy: 'Privacy',
      terms: 'Terms',
    },
    badges: {
      validationActive: 'Validation Active',
      connectionsChecked: 'All connections checked',
    },
  },
  help: {
    title: 'Help & Documentation',
    description: 'Overview of tools, shortcuts, and tips & tricks.',
    tabs: {
      tools: 'Tools',
      shortcuts: 'Shortcuts',
      tips: 'Tips & Tricks',
    },
    toolDescriptions: {
      select: 'Select and edit elements. Click an element to select it.',
      line: 'Draw lines between two points. First click = Start point, second click = End point. Points automatically snap to the isometric grid.',
      shape: 'Draw polygons. Click multiple points to define the shape. Click the first point or press Space to close the shape.',
      text: 'Add text. Click position and enter text.',
      pan: 'Move canvas. Click and drag to move view. Alternative: Middle mouse button or Shift+Drag in any tool.',
    },
    sections: {
      view: 'View',
      file: 'File',
      edit: 'Edit',
    },
    tips: {
      grid: {
        title: 'Isometric Grid',
        desc: 'The isometric grid uses 30° angles for a pseudo-3D representation. All points automatically snap to the grid.',
        sub: 'The red point marks the origin (0,0).',
      },
      shapes: {
        title: 'Creating Shapes',
        desc: 'To close a shape, click the first point again. At least 3 points are required.',
      },
      nav: {
        title: 'Navigation',
        zoom: 'Zoom: Mouse wheel or +/- keys',
        pan: 'Pan: Middle mouse button, Shift+Drag or H tool',
      },
      props: {
        title: 'Edit Properties',
        desc: 'Select an element to edit its properties in the right panel. You can adjust colors, stroke widths, fill, and more.',
      },
      save: {
        title: 'Saving Parts',
        desc: 'Save parts as .isompart files or to the built-in library. The library uses the browser\'s LocalStorage.',
      },
    },
  },
  attributes: {
    title: 'Attributes',
    add: 'Add',
    name: 'Name',
    type: 'Type',
    value: 'Value',
    description: 'Description',
    noAttributes: 'No attributes available',
    clickToAdd: 'Click + to add',
    original: 'Original',
    automatic: 'Automatic',
    types: {
      string: 'Text',
      number: 'Decimal',
      integer: 'Integer',
      boolean: 'Yes/No',
      url: 'URL',
      email: 'Email',
      dimension: 'Dimension',
      angle: 'Angle',
      dn: 'DN (Nominal Diameter)',
      dnReduction: 'DN Reduction',
      insertionDepth: 'Insertion Depth',
      roughness: 'Roughness',
      flowRate: 'Flow Rate',
      pressureLoss: 'Pressure Loss',
      velocity: 'Velocity',
      uValue: 'U-Value',
      thermalConductivity: 'Thermal Conductivity',
      wallThickness: 'Wall Thickness',
      insulationThickness: 'Insulation Thickness',
      temperature: 'Temperature',
      pressure: 'Pressure',
      power: 'Power',
      massFlow: 'Mass Flow',
      density: 'Density',
      viscosity: 'Viscosity',
    },
    groups: {
      general: 'General',
      tgaNominal: 'TGA - Nominal Diameters',
      tgaGeometry: 'TGA - Geometry',
      tgaFlow: 'TGA - Flow',
      tgaThermic: 'TGA - Thermic',
      tgaPhysical: 'TGA - Physical',
    },
  },
  background: {
    title: 'Background Settings',
    visible: 'Show Background',
    mode: 'Background Mode',
    color: 'Background Color',
    modes: {
      isometric: 'Isometric Grid',
      cartesian: 'Cartesian Grid',
      dots: 'Dots',
      none: 'None',
      description: 'No background is displayed. Only the background color is visible.',
    },
    isometric: {
      angle: 'Angle (Degrees)',
      gridSize: 'Grid Spacing (mm)',
      lineColor: 'Line Color',
      lineWidth: 'Line Width',
      pointColor: 'Point Color',
      pointSize: 'Point Size',
    },
    cartesian: {
      gridSize: 'Grid Spacing (mm)',
      lineColor: 'Line Color',
      lineWidth: 'Line Width',
      showMinor: 'Show Minor Lines',
      minorDivisions: 'Subdivisions',
      minorColor: 'Minor Line Color',
    },
    dots: {
      gridSize: 'Dot Spacing (mm)',
      color: 'Dot Color',
      size: 'Dot Size',
    },
  },
  dialogs: {
    connection: {
      title: 'Create Connection Point',
      label: 'Label',
      placeholder: 'e.g. Input, Output, Port',
    },
    blockDisplay: {
      title: 'Display Settings',
      useOverrides: 'Use Block-specific Settings',
      overridesDesc: 'Override global display settings for this block only.',
      lineWidth: 'Line Width Multiplier',
      connectionSize: 'Socket Size Multiplier',
      fontSize: 'Font Size Multiplier',
      global: 'Global',
      colorOverride: 'Color Override',
      noOverrides: 'This block uses global display settings.',
    },
    dimensionEdit: {
      title: 'Edit Dimension',
      description: 'Enter true length for bill of materials. The calculated length will be overridden.',
      calculatedLength: 'Calculated Length',
      calculatedDesc: 'Automatically calculated based on geometry',
      actualLength: 'True Length',
      actualDesc: 'This value will be used for bill of materials',
      overridden: 'Value overridden',
      displayed: 'Displayed',
    },
    addAttribute: {
      titleNew: 'Create New Attribute',
      titleEdit: 'Edit Attribute',
      nameLabel: 'Attribute Name *',
      namePlaceholder: 'e.g. Material, DN, Temperature',
      typeLabel: 'Data Type',
      targetLabel: 'Add to which objects? *',
      targetBlocks: 'Components (Blocks)',
      targetAllBlocks: 'All components ({count} instances)',
      targetSpecificBlock: 'Specific component',
      targetConnections: 'All connections ({count} instances)',
      fillModeLabel: 'How should values be filled?',
      fillEmpty: 'Leave empty',
      fillEmptyDesc: 'All values remain empty',
      fillSame: 'Same value for all',
      fillSameDesc: 'All objects receive the same value',
      fillNumbering: 'Sequential numbering',
      fillNumberingDesc: 'Objects are numbered (e.g. 1, 2, 3, ...)',
      fillCustom: 'Custom',
      fillCustomDesc: 'Enter values manually after creation',
      startValue: 'Start Value',
      prefix: 'Prefix (optional)',
      suffix: 'Suffix (optional)',
      preview: 'Preview:',
      createBtn: 'Create Attribute',
      saveBtn: 'Save',
      validationName: 'Please enter an attribute name.',
      validationTarget: 'Please select at least one object type.',
    },
    borderAreas: {
      title: 'Auto-format Areas',
      hint: 'Note: These settings automatically format the border lines of table areas (header and data) for optimal visual hierarchy.',
      headerBorder: 'Header Area (thick border)',
      dataBorder: 'Data Area (thick border)',
      innerGrid: 'Inner Grid (thin lines)',
      zebraStripes: 'Zebra Stripes (alternating background colors)',
      zebraStripesDesc: 'Every second row gets a slightly darker background for better readability.',
      color: 'Color:',
      width: 'Thickness:',
      thin: '1px (thin)',
      standard: '2px (standard)',
      medium: '3px (medium)',
      thick: '4px (thick)',
      apply: 'Apply',
    },
    mergeColumns: {
      title: 'Merge Columns',
      intro: 'The following columns will be merged:',
      labelName: 'Display name for merged column:',
      placeholder: 'e.g. Length',
      mergeBtn: 'Merge',
    },
    mergedColumn: {
      title: 'Merged Column',
      columnName: 'Column Name:',
      attributes: 'Merged Attributes ({count}):',
      info: 'ℹ️ This column displays values from multiple attributes. Objects with multiple values have been split into separate rows.',
      unmergeBtn: 'Unmerge',
    },
    renameColumn: {
      title: 'Change Display Name',
      label: 'New Display Name:',
      placeholder: 'e.g. Diameter&#10;outer',
      hint: 'The display name only overrides the presentation in the table. The original attribute remains unchanged.',
      tip: 'Tip: Press Enter for line breaks.',
      changeBtn: 'Change',
    },
  },
  sentry: {
    status: {
      banner: {
        title: 'Development mode: Sentry disabled',
        desc: 'Errors logged to console only',
      },
    },
    test: {
      title: 'Error Tracking Test',
      desc: 'Sentry Error Tracking is active. You can use this button to send a test error to verify that error capture is working correctly.',
      button: 'Send Test Error to Sentry',
      note: 'The test error will be marked with the tag "type: test" and will appear in your Sentry-Dashboard.',
    },
  },
  feedback: {
    title: 'Send Feedback',
    context: {
      title: 'Auto-detected Context',
      blocks: 'Blocks',
      connections: 'Connections',
      tool: 'Tool',
    },
    emailDisabled: {
      title: 'Email sending disabled',
      desc: 'EmailJS is not configured. Feedback will only be logged to the console.',
      showConfig: 'Show missing configuration',
      setupGuide: 'See EMAILJS_SETUP.md for setup instructions',
    },
    category: {
      label: 'What would you like to report?',
      bug: 'Bug',
      feature: 'Feature',
      improvement: 'Improvement',
    },
    description: {
      label: 'Description',
      placeholders: {
        bug: 'What happened?\\n- [Describe the problem here]\\n\\nExpected behavior?\\n- [What should happen instead?]\\n\\nSteps to reproduce?\\n1. [First step]\\n2. [Second step]\\n3. [Third step]',
        feature: 'What function do you want?\\n- [Describe the desired function]\\n\\nWhy do you need this function?\\n- [Explain the use case]\\n\\nHow should it work?\\n- [Describe the desired behavior]',
        improvement: 'What could be better?\\n- [Describe what should be improved]\\n\\nYour suggestion?\\n- [How should it be instead?]',
      },
    },
    options: {
      title: 'Additional Info',
      screenshot: 'Attach Canvas Screenshot (helps with bug fixes!)',
      devDetails: 'Attach Developer Details',
    },
    submit: {
      button: 'Send',
      sending: 'Sending...',
      success: 'Feedback sent! Thank you! 🎉',
      error: 'Error sending',
      screenshotSuccess: 'Screenshot captured!',
      screenshotError: 'Could not capture screenshot',
      noCanvas: 'No canvas element found',
      validation: 'Please enter a description',
      limitReached: 'Only {count} more feedback{suffix} possible this hour',
    },
    footer: 'Your feedback helps us get better! Thanks! 💙',
  },
  print: {
    settings: 'Settings',
    planName: 'Plan Name',
    format: 'Format',
    orientation: 'Orientation',
    scale: 'Scale (Viewport)',
    titleBlock: 'Title Block Data',
    project: 'Project',
    client: 'Client',
    projectNumber: 'Project No.',
    planNumber: 'Plan No.',
    date: 'Date',
    drawnBy: 'Drawn By',
    view: 'View',
    showCropMarks: 'Show Crop Marks',
    showIsoGrid: 'Show Iso Grid',
    print: 'Print',
    dxf: 'DXF',
    landscape: 'Landscape',
    portrait: 'Portrait',
    custom: 'Custom',
    placeholders: {
      project: 'Project name...',
      client: 'Client...',
    },
    messages: {
      viewportUnlocked: 'Viewport unlocked: Move/Zoom content',
      viewportLocked: 'Viewport locked',
      centerView: 'Center Content',
      centerContent: 'View centered',
      exportStarted: 'DXF Export started',
      exportFailed: 'DXF Export failed',
      noBlocks: 'No blocks to center',
      invalidCoords: 'Invalid coordinates',
      viewCentered: 'View centered',
      titleBlockActive: 'Title Block Editor active',
      load: 'Load',
      save: 'Save',
      done: 'Done',
      saveTemplateTitle: 'Save Title Block',
      saveTemplateDesc: 'Save current layout as template for future plans.',
      loadTemplateTitle: 'Load Title Block',
      loadTemplateDesc: 'Select a saved template to replace current layout.',
      noTemplates: 'No templates saved',
      shortcuts: 'Del: Clear content | Shift+Del: Delete row | Alt+Del: Delete column',
    },
  },
  table: {
    headers: {
      added: 'Header row added',
      inserted: 'Header row inserted',
      deleted: 'Header row deleted',
      reset: 'All header rows reset',
      updated: 'Header updated',
    },
    columns: {
      renamed: 'Column name updated',
      merged: '{count} columns merged horizontally',
      unmerged: 'Merge removed',
    },
    cells: {
      noSelection: 'No cells selected',
      minTwo: 'Select at least 2 cells',
      singleMerged: 'Select exactly 1 merged cell',
      notMerged: 'Cell is not merged',
      notAdjacent: 'Cells must be adjacent',
      notAdjacentVertical: 'Cells must be vertically adjacent',
      verticalSameColumn: 'Only cells from the same column can be vertically merged',
      invalidSelection: 'Invalid cell selection',
      horizontalMainError: 'Horizontal merge of main row is not supported',
      mainMergeError: 'Main row can only be merged with the bottom header row',
      mainMixError: 'Cannot mix main columns with header rows',
      mainVerticalError: 'Main columns can only be merged horizontally',
      rectangleError: 'Cells must form a rectangle',
      mergedHorizontal: 'Cells merged horizontally',
      mergedVertical: 'Cells merged vertically',
      mergedMain: 'Cells merged with main row',
      merged2D: 'Cells merged ({width}x{height})',
      splitHorizontal: 'Cell split horizontally',
      splitVertical: 'Cell split vertically',
      split2DError: '2D merged cells cannot be split yet',
      cellNotFound: 'Cell not found',
    },
    borders: {
      presetApplied: 'Border preset "{preset}" applied',
      widthApplied: 'Line width {width}px applied',
      formatted: 'Areas formatted',
      reset: 'Header rows and borders reset',
    },
    status: {
      rebuilt: 'Table rebuilt: {count} rows',
      projectLoaded: 'Project loaded{details}',
      loadError: 'Error loading project',
      saveError: 'Error saving project',
    },
    grouping: {
      activated: 'Grouping activated',
      deactivated: 'Grouping deactivated',
    },
    groupByPanel: {
      title: 'Grouping',
      groupBy: 'Group by',
      dragInstruction: 'Drag column here or select below',
      aggregations: 'Aggregations',
      subtotals: 'Show subtotals',
      grandTotal: 'Show grand total',
      reset: 'Reset',
      level: 'Level',
      addColumn: 'Add column...',
      none: 'None',
      count: 'Count',
      sum: 'Sum',
      avg: 'Average',
      min: 'Minimum',
      max: 'Maximum',
      first: 'First',
      last: 'Last',
      unique_count: 'Unique',
    },
    totals: {
      activated: 'Totals row activated',
      deactivated: 'Totals row deactivated',
    },
    printDialog: {
      title: 'Print / Export',
      tabs: {
        area: 'Area',
        format: 'Format',
        metadata: 'Metadata',
        preview: 'Preview',
      },
      presets: {
        title: 'Presets',
        desc: 'Quick configurations for frequent export scenarios',
        saveCurrent: 'Save current config',
        reset: 'Reset to defaults',
        standardPresets: 'Standard Presets',
        userPresets: 'User Presets',
        deleteConfirmTitle: 'Delete Preset',
        deleteConfirmDesc: 'Are you sure you want to delete the preset "{name}"? This action cannot be undone.',
        placeholderName: 'e.g. My Export',
        placeholderDesc: 'Optional',
        saveTitle: 'Save Preset',
        saveDesc: 'Save current configuration as a reusable preset',
        nameLabel: 'Preset Name *',
        descLabel: 'Description',
        saveBtn: 'Save Preset',
        deleteBtn: 'Delete',
        items: {
          'preset-full-table-pdf-a4': { name: 'Entire Table - PDF (A4)', desc: 'Export entire table as PDF in A4 format' },
          'preset-full-table-pdf-a3': { name: 'Entire Table - PDF (A3)', desc: 'Export entire table as PDF in A3 format (large)' },
          'preset-full-table-pdf-letter': { name: 'Entire Table - PDF (Letter)', desc: 'Export entire table as PDF in US Letter format' },
          'preset-full-table-excel': { name: 'Entire Table - Excel (CSV)', desc: 'Export entire table as CSV file' },
          'preset-selection-only-pdf': { name: 'Selected Area - PDF', desc: 'Export only selected cells as PDF' },
          'preset-compact-pdf': { name: 'Compact PDF', desc: 'Minimal margins, no metadata, small font' },
          'preset-portrait-a5': { name: 'Compact - PDF (A5 Portrait)', desc: 'Small format export for compact prints' },
        },
      },
      area: {
        title: 'Select Print Area',
        subtitle: 'Choose which part of your table should be exported',
        options: {
          entireTable: { title: 'Entire Table', desc: 'Export all visible rows and columns' },
          selectedRange: { title: 'Selected Area', desc: 'Export a specific range of cells' },
          selectedColumns: { title: 'Selected Columns', desc: 'Export specific columns (all rows)' },
          selectedRows: { title: 'Selected Rows', desc: 'Export specific rows (all columns)' },
          custom: { title: 'Custom Selection', desc: 'Define a custom export area' },
        },
        range: {
          title: 'Define Range',
          desc: 'Specify start and end indices for rows/columns',
          startRow: 'Start Row',
          endRow: 'End Row',
          startCol: 'Start Column',
          endCol: 'End Column',
        },
        columns: {
          title: 'Select Columns',
          desc: 'Choose which columns to export (all rows included)',
        },
        rows: {
          title: 'Select Rows',
          desc: 'Choose which rows to export (all columns included)',
          rowLabel: 'Row {index}',
        },
        headers: {
          title: 'Header Options',
          desc: 'Configure which headers should be included in the export',
          includeColumns: 'Include column headers',
          includeRows: 'Include multi-level headers',
          noHeaders: '(No headers defined)',
        },
      },
      format: {
        title: 'Output Format',
        subtitle: 'Choose export format and configure options',
        exportFormat: {
          title: 'Export Format',
          desc: 'Choose PDF or Excel/CSV output',
          pdf: { title: 'PDF Document', desc: 'Professional PDF with formatting, page numbers, and metadata' },
          excel: { title: 'Excel / CSV', desc: 'Spreadsheet format compatible with Excel, Google Sheets, etc.' },
        },
        pageSetup: {
          title: 'Page Setup',
          desc: 'Configure page size and orientation',
          size: 'Page Size',
          orientation: 'Orientation',
          portrait: 'Portrait',
          landscape: 'Landscape',
        },
        margins: {
          title: 'Margins',
          desc: 'Set page margins in millimeters',
          top: 'Top (mm)',
          bottom: 'Bottom (mm)',
          left: 'Left (mm)',
          right: 'Right (mm)',
        },
        typography: {
          title: 'Typography',
          desc: 'Fonts for the PDF',
          size: 'Font Size',
          font: 'Font Family',
          range: '{min}–{max} pt',
        },
        display: {
          title: 'Display Options',
          desc: 'Additional PDF features',
          gridLines: 'Show grid lines',
          metadataHeader: 'Include metadata header',
          pageNumbers: 'Include page numbers',
          pagePos: 'Page number position',
          posLeft: 'Bottom Left',
          posCenter: 'Bottom Center',
          posRight: 'Bottom Right',
          customFields: 'Display custom fields',
          cfNone: 'Do not display (only in PDF properties)',
          cfAbove: 'Above table',
          cfBelow: 'Below table',
          cfNote: 'Custom fields are always saved in PDF file properties. This option controls only visual display in the document.',
        },
        csv: {
          title: 'CSV Options',
          desc: 'Configure CSV export settings',
          separator: 'Column Separator',
          comma: 'Comma (,)',
          semicolon: 'Semicolon (;)',
          tab: 'Tab (\\t)',
          formulas: 'Include formulas',
          styles: 'Include cell styles',
          notSupported: '(not supported in CSV)',
          projectMetadata: 'Export project data',
          metadataNote: 'If enabled, all metadata (project name, author, custom fields, etc.) will be inserted as header lines at the beginning of the CSV file.',
        },
      },
      metadata: {
        title: 'Document Metadata',
        subtitle: 'Add information to be included in the exported document',
        project: {
          title: 'Project Information',
          desc: 'Basic project details',
          name: 'Project Name *',
          namePlaceholder: 'Enter project name',
          description: 'Project Description',
          descPlaceholder: 'Optional project description or notes',
          version: 'Version',
        },
        author: {
          title: 'Author & Organization',
          desc: 'Who created this document',
          name: 'Author Name',
          namePlaceholder: 'Your Name',
          company: 'Company / Organization',
          companyPlaceholder: 'Company Name',
        },
        dates: {
          title: 'Dates',
          desc: 'Project timeline information',
          created: 'Created',
          modified: 'Modified',
          printed: 'Print Date (Read-only)',
          autoUpdate: 'Automatically updated on export',
        },
        custom: {
          title: 'Custom Fields',
          desc: 'Add custom metadata fields (e.g. Department, Location, Project Number)',
          fieldName: 'Field Name',
          value: 'Value',
          addBtn: 'Add New Field',
          empty: 'No custom fields present. Add fields to capture additional information.',
        },
      },
      preview: {
        title: 'Print Preview',
        subtitle: 'Preview your export before downloading',
        rows: 'Total Rows',
        cols: 'Columns',
        headers: 'Headers',
        format: 'Format',
        notes: {
          title: 'Export Notes:',
          pdfSize: '• PDF created with {size} page size in {orientation}',
          pdfFont: '• Font: {font}, Size: {size}pt',
          pdfGrid: '• Grid lines included',
          csvSep: '• CSV file uses {sep} as separator',
          csvCompat: '• File is compatible with Excel, Google Sheets, and other spreadsheet programs',
        },
      },
      actions: {
        back: 'Back',
        next: 'Next',
        cancel: 'Cancel',
        export: 'Export Now',
        exporting: 'Exporting...',
        exportPreview: 'Export',
      },
    },
    toolbar: {
      cells: 'Cells',
      merge: 'Merge',
      split: 'Split',
      borders: 'Borders',
      borderPresets: 'Border Presets',
      lineWidth: 'Line Width',
      thickness: 'Thickness',
      areas: 'Areas',
      table: 'Table',
      column: 'Column',
      row: 'Row',
      data: 'Data',
      group: 'Group',
      totalsRow: 'Totals Row',
      clearSelection: 'Clear Selection',
      dataRows: 'Data Rows',
      reloadValues: 'Reload values from blocks (keeps structure)',
      resetHeaders: 'Reset all headers',
      resetHeadersConfirm: 'Reset all headers and vertical connections?',
      editBorders: 'Edit borders',
      toggleGrid: 'Grid lines',
      print: 'Print',
      loadTemplate: 'Load template',
      selection: 'Selection: {rows} × {cols}',
      borderPresetsNames: {
        outerThick: 'Thick Outer Border',
        allBorders: 'All Borders',
        noBorders: 'No Borders',
        horizontalOnly: 'Horizontal Only',
        verticalOnly: 'Vertical Only',
        innerGrid: 'Inner Grid',
      },
      columns: 'Columns',
      rows: 'Rows',
      headerRows: 'Header Rows',
    },
    sidebar: {
      attributes: 'Attributes',
      createAttribute: 'Create new attribute',
      noAttributes: 'No attributes available',
      clickToAdd: 'Click + to add',
      used: 'used',
      editAttribute: 'Edit attribute',
      deleteAttribute: 'Delete attribute',
      confirmDelete: 'Really delete attribute "{name}"?',
      total: 'total',
      dragHint: 'Drag attributes into the table',
      types: {
        both: 'Blocks & Connections',
        block: 'Blocks',
        connection: 'Connections',
      },
    },
    grid: {
      dragHere: 'Drag attributes here',
      dropHere: 'Drop attribute here',
      dragInstruction: 'Select attributes from the left panel and drag them into the table',
      addHeaderRow: 'Add header row',
    },
  },
  tutorial: {
    welcome: {
      title: 'Welcome to ISOCAD! 👋',
      subtitle: 'Interactive Tutorial - Learn ISOCAD in 3 Easy Steps',
      workflowTitle: 'The ISOCAD Workflow:',
      step1Title: 'ISO.BLOCK',
      step1Desc: 'Construct components',
      step2Title: 'BLOCK.SYSTEM',
      step2Desc: 'Build systems & print',
      step3Title: 'SYSTEM.TABLE',
      step3Desc: 'Create bills of materials',
      modulesTitle: 'Choose a tutorial module:',
      neverShowAgain: 'Don\'t show tutorial again',
      loading: 'Loading tutorial...',
      loadingDesc: 'Please wait a moment.',
    },
    progress: {
      step: 'Step',
      of: 'of',
      completed: 'Completed',
      inProgress: 'In Progress',
    },
    actions: {
      start: 'Start Tutorial',
      next: 'Next',
      previous: 'Previous',
      skip: 'Skip',
      close: 'Close',
      restart: 'Restart',
      complete: 'Complete',
      minimize: 'Minimize',
      maximize: 'Maximize',
      undo: 'Undo',
      toggleSound: 'Toggle Sound',
    },
    status: {
      completed: '✅ Completed',
      notStarted: 'Not started yet',
      estimatedTime: 'Estimated duration',
    },
    messages: {
      conditionNotMet: 'Perform the specified action to continue',
      waitingForAction: 'Waiting for your action...',
      stepComplete: 'Step complete! 🎉',
      moduleComplete: 'Module complete! 🎉',
      allModulesComplete: 'All modules completed! You are now an ISOCAD expert! 🚀',
    },
    keyboard: {
      title: 'Keyboard Shortcuts',
      hint: 'Or press',
      shortcuts: 'Show shortcuts',
    },
  },
};

export const translations = { de, en };
